import { stringify } from "flatted";

var setStateCallbacks = function ($rootScope, $location) {
  var previousPage = $location.path();

  $rootScope.$on("$stateChangeStart", function (event, toState, toParams, from, fromParams) {
    $rootScope.previousUrl = $location.$$url;
    $rootScope.previousParams = fromParams;
  });

  $rootScope.$on("$stateChangeSuccess", function () {
    if ($location.path() != previousPage) {
      window.scrollTo(0, 0);
      previousPage = $location.path();
      $rootScope.previousPageForBack = previousPage;
    }
  });

  $rootScope.$on(
    "$stateChangeError",
    function (event, toState, toParams, fromState, fromParams, error) {
      let errString = "";
      try {
        errString = stringify(error);
      } catch (err) {
        errString = "could not stringify error";
      }
      console.log("Something went wrong!", errString, event, error);
    },
  );
};
export default setStateCallbacks;
